import { useTranslation } from 'react-i18next';
import { useCallHistoryManagementFilters } from 'infrastructure/hooks/callHistoryManagement/useFilters';

import s from './styles.module.scss';
import Input from './input';

import type { ReactNode, FC } from 'react';
import type { AppendFilters } from 'infrastructure/hooks/callHistoryManagement/types';

const Wrapper: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className={s['filter-wrapper']}>{children}</div>;
};

const Body: FC = () => {
  const { t } = useTranslation();

  const { updateFilter, filter } = useCallHistoryManagementFilters();

  const appendFiltersAndResetPage: AppendFilters = (newFilter) => {
    updateFilter({ page: undefined, ...newFilter });
  };

  return (
    <div className={s.wrapper}>
      <Wrapper>
        <Input
          value={filter.callId}
          onChange={(value) => {
            appendFiltersAndResetPage({ callId: value });
          }}
          label={t('labels.callId')}
          id="search-by-call-id"
          placeholder={t('placeholders.searchByCallId')}
        />
      </Wrapper>
      <Wrapper>
        <Input
          value={filter.phone}
          onChange={(value) => {
            appendFiltersAndResetPage({ phone: value });
          }}
          label={t('labels.patientPhone')}
          id="search-by-patient-phone"
          placeholder={t('placeholders.searchByPatientPhone')}
        />
      </Wrapper>
      <Wrapper>
        <Input
          value={filter.patientGuid}
          onChange={(value) => {
            appendFiltersAndResetPage({ patientGuid: value });
          }}
          label={t('labels.patientGuid')}
          id="search-by-patient-guid"
          placeholder={t('placeholders.searchByPatientGuid')}
        />
      </Wrapper>
      <Wrapper>
        <Input
          value={filter.agent}
          onChange={(value) => {
            appendFiltersAndResetPage({ agent: value });
          }}
          label={t('labels.agent')}
          id="search-by-agent-email"
          placeholder={t('placeholders.searchByAgentEmail')}
        />
      </Wrapper>
    </div>
  );
};

export default Body;
